import { getDateRangeWindow } from '@modules/common/utils';
import { ShowFeedbackDrawerFromTableOptions } from '@modules/quantify/components/QuantifyReportTableWidget/types';
import { getTooltipTitleForFormulaValueCell } from '@modules/quantify/hooks/useGetQuantifyReportTableColumns/helpers/getTooltipTitleForFormulaValueCell';
import {
  QuantifyQuery,
  VisualisationType,
} from '@modules/quantify/store/types';
import { Link, Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { EqlField } from 'generated/graphql';
import { SyntheticEvent } from 'react';
import { AggregatePeriod } from 'v2/core/entities';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface renderDynamicColumnCellParams {
  params: GridRenderCellParams;
  variantId: string;
  activeVisualisationType: VisualisationType;
  aggregatePeriod: AggregatePeriod;
  onFeedbackCountClick: (params: ShowFeedbackDrawerFromTableOptions) => void;
  groupBy: QuantifyQuery['groupBy'];
  formulaID: EQLFunctionName;
  measuredAsCriteria: EqlField | null;
  shouldRemoveFileUploadPrefix: boolean;
  isUnifiedFieldEnabled: boolean;
}

export function renderDynamicColumnCell({
  params,
  variantId,
  activeVisualisationType,
  aggregatePeriod,
  onFeedbackCountClick,
  groupBy,
  formulaID,
  measuredAsCriteria,
  shouldRemoveFileUploadPrefix,
  isUnifiedFieldEnabled,
}: renderDynamicColumnCellParams) {
  if (!params.value) {
    return params.value;
  }

  const getDateRange = () => {
    if (variantId && activeVisualisationType === VisualisationType.TREND) {
      return getDateRangeWindow({
        timestamp: Number(variantId),
        aggregatePeriod,
      });
    }
  };

  const onClick = (event: SyntheticEvent) => {
    event.stopPropagation();

    onFeedbackCountClick({
      id: params.row.id,
      label: params.row.label,
      category: params.row.category,
      dateRange: getDateRange(),
      isInvisible: params.row.isInvisible,
      isUpdateInProgress: params.row.isUpdateInProgress,
    });
  };

  return (
    <Tooltip
      arrow
      title={getTooltipTitleForFormulaValueCell({
        groupBy,
        formulaID,
        displayName: params.row.label,
        feedbackCount: params.value,
        params,
        measuredAsCriteria,
        shouldRemoveFileUploadPrefix,
        isUnifiedFieldEnabled,
      })}
      placement="top"
      disableInteractive
    >
      <Link
        component="button"
        variant="body1"
        onClick={onClick}
        color="primary"
        underline="hover"
      >
        {params.value || 0}
      </Link>
    </Tooltip>
  );
}
